// extracted by mini-css-extract-plugin
export default {"noBorder":"DataView_noBorder__3Q4b9","JsonTree":"DataView_JsonTree__LXYfj","DataViewContainer":"DataView_DataViewContainer__C-bb6","InfoTable":"DataView_InfoTable__Aic8u"};